import React from "react";
import logger from "logger";
import ToolTip from "@material-ui/core/ToolTip";
import Switch from "@material-ui/core/Switch";

export const ServiceToggle = (props) => {
  const { label, tooltip, onClick, value } = props;
  return (
    <div style={{ display: "inline-flex" }}>
      <ToolTip title={tooltip}>
        <div
          className="servicecardcell"
          style={{ margin: "auto 0", flex: "1" }}
        >
          {label}
        </div>
      </ToolTip>
      <div className="servicecardcell">
        <Switch checked={value} onClick={onClick} />
      </div>
    </div>
  );
};
